<template>
  <b-modal
    v-model="trigger"
    :centered="true"
    :no-close-on-backdrop="dontCloseWhenClickedOutside"
    :no-close-on-esc="dontCloseWhenEscapePressed"
    :hide-header-close="dontShowCloseIcon"
    :hide-footer="true"
    :hide-header="true"
    @cancel="eventCancel($event)"
    :size="'lg'"
  >
    <div class="empanel-modal-close">
      <span v-if="!isEdit" class="Modal-head-text">Add Branch Details</span>
      <span v-if="isEdit" class="Modal-head-text">Edit Branch Details</span>
      <p class>
        <img
          @click="closeContactModal()"
          class="cursor-pointer modal-close-button mt-n1"
          style="float:right"
          src="@/assets/images/close1.svg"
        />
      </p>
    </div>
    <div class="col-12 mt-3">
      <b-form-group class="source-sans-pro bold text-left ml-3 mr-3 mb-0" label="Branch"></b-form-group>
    </div>
    <div class="row ml-3 mr-3">
      <div class="col-6 p-0" v-if="!isCustomer">
        <b-form-group class="source-sans-pro text-left ml-3 mr-3" label="Partner Type">
          <w-dropdown
            class="width-control-small"
            :options="parentPartnerTypes"
            @dropdownChange="getParentPartnerType($event)"
            :selected="selectedPartnerType"
          />
          <p
            class="ml-3 font-weight-bold text-danger lato-regular"
            v-if="partnerTypeExist"
          >Select Partner type</p>
        </b-form-group>
      </div>
      <div class="col-6 p-0">
        <b-form-group class="source-sans-pro text-left ml-3 mr-3">
          <w-text-input         
                  :labelName="$t('Branch Name')"  
            class="text-left"
            @textInputChange="getBranchName($event)"
            validation="required"
            :defaultValue="branchName"
            :allowOnlyCharacters="true"
            :maxCharacter="'100'"
            :disabled="!selectedPartnerType"
          />
          <p
            class="ml-3 font-weight-bold text-danger lato-regular"
            v-if="branchNameExist"
          >Branch Name is already exist</p>
        </b-form-group>
      </div>
    </div>
    <div class="col-12">
      <b-form-group class="source-sans-pro bold text-left ml-3 mr-3 mb-0" label="Address"></b-form-group>
    </div>
    <div class="col-12">
      <b-form-group class="source-sans-pro text-left ml-3 mr-3" label="Street">
        <w-text-input
          class="text-left"
          @textInputChange="getBranchStreet($event)"
          validation="required"
          :defaultValue="branchStreet"
          :maxCharacter="'100'"
          :disabled="!selectedPartnerType"
        />
        <p
          class="ml-3 font-weight-bold text-danger lato-regular"
          v-if="branchStreetExist"
        >Street Addres is already exist</p>
      </b-form-group>
    </div>
    <div class="row ml-3 mr-3">
      <div class="col-3 p-0">
        <b-form-group class="source-sans-pro text-left ml-3 mr-3" label="Country">
          <w-dropdown
            class="width-control-small"
            :options="branchCountries"
            @dropdownChange="getBranchCountry($event)"
            :selected="parentCountryCode"
            :disabled="true"
          />
        </b-form-group>
      </div>
      <div class="col-3 p-0">
        <b-form-group class="source-sans-pro text-left ml-3 mr-3" label="State">
          <w-dropdown
            class="width-control-small"
            :options="branchStates"
            @dropdownChange="getBranchState($event)"
            :selected="selectedState"
          />
        </b-form-group>
      </div>
      <!-- </div>
      <div class="row ml-3 mr-3">-->
      <div class="col-3 p-0">
        <b-form-group class="source-sans-pro text-left ml-3 mr-3" label="City">
          <w-dropdown
            class="width-control-small"
            :options="branchCities"
            @dropdownChange="getBranchCity($event)"
            :selected="selectedCity"
            :disabled="!selectedState"
          />
        </b-form-group>
      </div> 
      <div class="col-3 p-0">
        <b-form-group class="source-sans-pro text-left ml-3 mr-3" label="Zipcode">
          <!-- :labelName="$t('Zipcode')" -->
          <w-text-input
            class="text-left source-sans-pro"
            @textInputChange="getBranchZipCode($event)"
            :validation="zipValidation(parentCountryCode)"
            :defaultValue="branchZipCode"
            :inputAdditions="'mobile'"
            :maxDigits="parentCountryCode == 100 ? '6':'15'"
          />
          <p
            class="ml-3 font-weight-bold text-danger lato-regular"
            v-if="zipCodeValid && parentCountryCode == 100"
          >Zipcode must be 6 digit number</p>
        </b-form-group>
      </div>
    </div>
    <div class="col-12 mt-3">
      <b-form-group class="source-sans-pro bold text-left ml-3 mr-3 mb-0" label="Contact"></b-form-group>
    </div>
    <div class="row ml-3 mr-3">
      <div class="col-6 p-0">
        <b-form-group class="source-sans-pro text-left ml-3 mr-3" label="Coordination Person Name">
          <w-text-input
            class="text-left"
            @textInputChange="getBranchContactPerson($event)"
            validation="required"
            :defaultValue="branchContactPerson"
            :allowOnlyCharacters="true"
            :maxCharacter="'100'"
          />
        </b-form-group>
      </div>
      <div class="col-6 p-0">
        <b-form-group class="source-sans-pro text-left ml-3 mr-3" label="Designation">
          <w-text-input
            class="text-left"
            @textInputChange="getBranchContactDesignation($event)"
            validation="required"
            :defaultValue="branchContactDesignation"
            :allowOnlyCharacters="true"
            :maxCharacter="'100'"
          />
        </b-form-group>
      </div>
    </div>
    <div class="row ml-3 mr-3">
      <div class="col-6 p-0"> 
        <b-form-group class="source-sans-pro text-left ml-3 mr-3" label="Mobile Number">
          <!-- :labelName="$t('Mobile Number')" -->
          <w-text-input
            class="text-left source-sans-pro"
            :inputAdditions="'mobile'"
            :validation="mobileValidationObj()"
            @textInputChange="getBranchContactMobile($event)"            
                        :maxDigits="phoneNumberLength"
                        :isdCode="phoneNumberCode"
            :defaultValue="branchContactMobile"
            :type="'number'"
            :disabled="!selectedPartnerType"
          />
          <p
            class="ml-3 font-weight-bold text-danger lato-regular"
            v-if="mobileNumberExists"
          >Mobile Number is already used</p>
          <p
            class="ml-3 font-weight-bold text-danger lato-regular"
            v-if="mobileNumberValid"
          >Mobile Number must be valid.</p>
        </b-form-group>
      </div>
      <div class="col-6 p-0">
        <b-form-group class="source-sans-pro text-left ml-3 mr-3" label="Email">
          <!-- :labelName="$t('Email')" -->
          <w-text-input
            class="text-left source-sans-pro"
            @textInputChange="getBranchContactEmail($event)"
            validation="required|email"
            :defaultValue="branchContactEmail"
            :maxCharacter="'100'"
            :disabled="!selectedPartnerType"
          />
          <p
            class="ml-3 font-weight-bold text-danger lato-regular"
            v-if="emailExists"
          >Email-Id is already used</p>
          <p
            class="ml-3 font-weight-bold text-danger lato-regular"
            v-if="emailValid"
          >Email must be a valid email.</p>
          <p
            class="ml-3 font-weight-bold text-danger lato-regular"
            v-if="restrictEmail"
          >Email ID of this domain is Restricted!</p>
        </b-form-group>
      </div>
    </div>
    <div class="row text-center mr-3 mb-3">
      <div class="col">
        <b-button
          class="add-branch-btn-class"
          :disabled="!allFieldsPresent()"
          @click="saveBranchDetails()"
          v-if="isEdit"
        >Update</b-button>
        <b-button class="add-branch-btn-class" @click="clearAllFields()" v-if="!isEdit">Clear</b-button>&nbsp;
        <b-button
          class="add-branch-btn-class"
          :disabled="!allFieldsPresent()"
          @click="saveBranchDetails()"
          v-if="!isEdit && !isAdmin && !isCustomer"
        >Save as Draft</b-button>&nbsp;
        <b-button
          class="add-branch-btn-class"
          :disabled="!allFieldsPresent()"
          @click="submitBranchDetails()"
          v-if="!isEdit"
        >Submit</b-button>
      </div>
    </div>
    <confirmationModal
      v-if="triggerConfirmModal"
      :trigger="triggerConfirmModal"
      :text="lastResponseConfirm"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      @eventOk="callAfterConfirmModal()"
      @eventCancel="closeConfirmModal()"
    />
    <widgetModal
      :trigger="triggerModalWidget"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModal"
      :showSuccess="successModal"
      @eventClose="changeModalSuccess()"
    />
    <w-loadingSpinner :loadSpinner="loading" />
  </b-modal>
</template>

<script>
import loadingSpinner from "../widgets/LoadingSpinner";
import DropDown from "../widgets/DropDown";
import TextInput from "../widgets/TextInput";
import { PartnerService } from "../services/partnerService";
const partnerService = new PartnerService();
import { OnBoardingServices } from "../services/onBoardingService";
const OnBoardingService = new OnBoardingServices();
import widgetModal from "../widgets/newModalWidget";
import confirmationModal from "../widgets/confirmationModal";
import { RegistrationService } from "../services/RegistrationService.js";
const RegisterService = new RegistrationService();

export default {
  components: {
    "w-dropdown": DropDown,
    "w-text-input": TextInput,
    "w-loadingSpinner": loadingSpinner,
    widgetModal,
    confirmationModal
  },
  props: [
    "trigger",
    "dontCloseWhenClickedOutside",
    "dontShowCloseIcon",
    "dontCloseWhenEscapePressed",
    "isEdit",
    "editBranchDetails",
    "isAdmin",
    "isCustomer",
    "pId",
    "selectedCompanyCode"
  ],
  data() {
    return {
      parentCountryCode:'',
      
       phoneNumberCode:'',
       phoneNumberLength:'',
      loading: false,
      companycode: "",
      parentPartnerTypes: [
        { value: null, text: "Select Partner type", disabled: true }
      ],
      selectedPartnerType: "",
      branchName: "",
      branchNameExist: false,
      branchStreet: "",
      branchStreetExist: false,
      branchCountries: [
        { value: null, text: "Select Country", disabled: true }
      ],
      selectedCountry: "",
      branchStates: [{ value: null, text: "Select State", disabled: true }],
      selectedState: "",
      branchCities: [{ value: null, text: "Select State", disabled: true }],
      selectedCity: "",
      branchZipCode: "",
      zipCodeValid: false,
      branchContactPerson: "",
      branchContactDesignation: "",
      branchContactMobile: "",
      mobileNumberExists: false,
      mobileNumberValid: false,
      branchContactEmail: "",
      emailExists: false,
      emailValid: false,
      savedBranches: [],
      editBranch: [],
      triggerModalWidget: false,
      lastResponse: "",
      modalTitle: "Partner Portal",
      alertModal: false,
      successModal: false,
      triggerConfirmModal: false,
      lastResponseConfirm: "",
      restrictEmail: false
    };
  },
  created() {
    this.getPartnerInfo();
    // this.getEditBranchDetails();
    if(this.isCustomer){
      this.selectedPartnerType = 5
    }
  },
  methods: {
    mobileValidationObj(){
      if(this.parentCountryCode==100){
        return {required: true, regex_mobile_number: true, length: this.phoneNumberLength}
      } else {
        return {required: true, min:6}
      }     
    },
    zipValidation(countryCode){
      if(countryCode==100){
        return "required|max:6|min:6|regex_zip_code"
      } else {
        return "required|regex_intl_zip_code"
      }
    },
    getEditBranchDetails() {
      if (this.isEdit == true && this.editBranchDetails) {
        this.editBranch = this.editBranchDetails;
        this.selectedPartnerType = this.editBranch.categoryCode;
        this.branchName = this.editBranch.branchName;
        this.branchStreet = this.editBranch.streetAddress;
        this.selectedCountry = this.editBranch.countryCode;
        this.selectedState = this.editBranch.stateCode;
        this.getBranchCities();
        this.selectedCity = this.editBranch.cityCode;
        this.branchZipCode = this.editBranch.zipCode;
        this.branchContactPerson = this.editBranch.contactPersonName;
        this.branchContactDesignation = this.editBranch.contactPersonDesignation;
        this.branchContactMobile = this.editBranch.mobileNumber;
        this.branchContactEmail = this.editBranch.email;
        this.getParentPartnerType(this.selectedPartnerType);
      }
    },
    getPartnerInfo() {
      this.loading = true;
      var self = this
      partnerService.getPartnerInfo(this.isAdmin || this.isCustomer, self.pId).then(resp => {
        this.companycode = resp.response.currentCompanyCode;
        this.parentCountryCode = resp.response.countryDetail.countryCode;
        this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
              
        this.phoneNumberCode = resp.response.countryDetail.isdCode;
        this.phoneNumberLength = 
        resp.response.countryDetail.sizeOfMobileNumber ? 
        resp.response.countryDetail.sizeOfMobileNumber : 15;
        this.getCountriesForBranch();
        this.getStatesForBranch();
        partnerService.getPartnertype(this.companycode, self.pId).then(resp => {
          if (resp.response) {
            resp.response.forEach((item, index) => {
              if (item.status == "A") {
                this.parentPartnerTypes.push({
                  text: item.description,
                  value: item.partnerTypeCode
                });
              }
            });
            this.getEditBranchDetails();
            this.loading = false;
          }
        });
      });
    },
    closeContactModal() {
      this.$emit("eventClose", event);
    },
    getParentPartnerType(event) {
      this.selectedPartnerType = event;
      partnerService
        .getPartnerAllBranches(event, this.companycode)
        .then(res => {
          console.log(res.response);
          console.log(this.editBranchDetails);
          var temp = [];
          if (this.isEdit) {
            for (let i = 0; i < res.response.length; i++) {
              if (
                res.response[i].id.branchId != this.editBranchDetails.branchId
              ) {
                temp.push(res.response[i]);
              }
            }
            this.savedBranches = temp;
          } else {
            this.savedBranches = res.response;
          }
          for (let i = 0; i < this.savedBranches.length; i++) {
            if (
              this.savedBranches[i].branchName.toLowerCase() ==
              this.branchName.toLowerCase()
            ) {
              this.branchNameExist = true;
              break;
            } else {
              this.branchNameExist = false;
            }
            if (
              this.savedBranches[i].streetAddress.toLowerCase() ==
                this.branchStreet.toLowerCase() &&
              this.savedBranches[i].stateCode == this.selectedState &&
              this.savedBranches[i].cityCode == this.selectedCity
            ) {
              this.branchStreetExist = true;
              break;
            } else {
              this.branchStreetExist = false;
            }
          }
        })
        .catch();
    },
    getBranchName(event) {
      for (let i = 0; i < this.savedBranches.length; i++) {
        if (
          this.savedBranches[i].branchName.toLowerCase() == event.toLowerCase()
        ) {
          this.branchNameExist = true;
          break;
        } else {
          this.branchNameExist = false;
        }
      }
      this.branchName = event;
    },
    getBranchStreet(event) {
      for (let i = 0; i < this.savedBranches.length; i++) {
        if (
          this.savedBranches[i].streetAddress.toLowerCase() ==
            event.toLowerCase() &&
          this.savedBranches[i].stateCode == this.selectedState &&
          this.savedBranches[i].cityCode == this.selectedCity
        ) {
          this.branchStreetExist = true;
          break;
        } else {
          this.branchStreetExist = false;
        }
      }
      this.branchStreet = event;
    },
    getCountriesForBranch() {
      this.branchCountries = [];
      OnBoardingService.getCountriesForRegdOffice()
        .then(resp => {
          if (resp.response) {
            resp.response.forEach(country => {
              this.branchCountries.push({
                text: country.longDesc,
                value: country.countryCode
              });
            });
          }
        })
        .catch(err => {
                window.alert("Something went wrong! try again later");
          console.log(err);
        });
    },
    getBranchCountry(event) {
      this.selectedCountry = event;
    },
    getStatesForBranch() {
      this.branchStates = [];
      this.selectedCountry = this.parentCountryCode;
      OnBoardingService.getStatesForRegisteredOffice(this.selectedCountry).then(
        resp => {
          resp.response.forEach(state => {
            this.branchStates.push({
              text: state.longDescr,
              value: state.stateCode
            });
          });
        }
      );
    },
    getBranchState(event) {
      for (let i = 0; i < this.savedBranches.length; i++) {
        if (
          this.savedBranches[i].streetAddress.toLowerCase() ==
            this.branchStreet.toLowerCase() &&
          this.savedBranches[i].stateCode == event &&
          this.savedBranches[i].cityCode == this.selectedCity
        ) {
          this.branchStreetExist = true;
          break;
        } else {
          this.branchStreetExist = false;
        }
      }
      this.selectedState = event;
      this.getBranchCities();
    },
    getBranchCities() {
      this.branchCities = [];
      OnBoardingService.getCityForRegisteredOffice(this.selectedState).then(
        resp => {
          if (resp.response) {
            var branchCity = [];
            resp.response.forEach(state => {
              branchCity.push({
                text: state.cityName,
                value: state.cityCode
              });
              this.$forceUpdate();
              this.branchCities = branchCity;
            });
          }
          if (this.editBranch) {
            this.selectedCity = this.editBranch.cityCode;
          }
        }
      );
    },
    getBranchCity(event) {
      for (let i = 0; i < this.savedBranches.length; i++) {
        if (
          this.savedBranches[i].streetAddress.toLowerCase() ==
            this.branchStreet.toLowerCase() &&
          this.savedBranches[i].stateCode == this.selectedState &&
          this.savedBranches[i].cityCode == event
        ) {
          this.branchStreetExist = true;
          break;
        } else {
          this.branchStreetExist = false;
        }
      }
      this.selectedCity = event;
    },
    getBranchZipCode(event) {
      this.branchZipCode = event;
      let isnum = /^\d+$/.test(this.branchZipCode); 
      if (this.branchZipCode.length == 6 && this.parentCountryCode == 100 && isnum) {
        this.zipCodeValid = false;
      } else {
        this.zipCodeValid = true;
      }
      if(this.parentCountryCode != 100){
        this.zipCodeValid = false
      }
    },
    getBranchContactPerson(event) {
      this.branchContactPerson = event;
    },
    getBranchContactDesignation(event) {
      this.branchContactDesignation = event;
    },
    getBranchContactMobile(event) {
      let isnum = /^\d+$/.test(event); 


      this.mobileNumberExists = false;
      if (((event.length == 10 && this.parentCountryCode==100) || (event.length >= 6 && this.parentCountryCode != 100)) && isnum) {
        this.mobileNumberValid = false;
        if (!this.mobileNumberExists) {
          OnBoardingService.mobileNumberUniqueness(event).then(resp => {
          if (resp.failureMessage.toLowerCase().indexOf("already exists")>-1) {
              this.mobileNumberExists = true;
            } else {
              for (let i = 0; i < this.savedBranches.length; i++) {
                if (
                  this.savedBranches[i].mobileNumber.toLowerCase() ==
                  event.toLowerCase()
                ) {
                  this.mobileNumberExists = true;
                  break;
                } else {
                  this.mobileNumberExists = false;
                }
              }
            }
          });
        }
      } else {
        this.mobileNumberValid = true;
        this.mobileNumberExists = false;
      }
      this.branchContactMobile = event;
    },
    getBranchContactEmail(event) {
      var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (!event.match(mailformat)) {
        this.emailValid = true;
        this.emailExists = false;
      } else {
        this.emailValid = false;
      }
      this.emailExists = false;
      let emailRegex = new RegExp("^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$");
      if (emailRegex.test(event.toLowerCase())) {
        if (!this.emailExists) {
          OnBoardingService.emailUniqueness(event).then(resp => {
          if (resp.failureMessage.toLowerCase().indexOf("already exists")>-1) {
              this.emailExists = true;
            } else {
              for (let i = 0; i < this.savedBranches.length; i++) {
                if (
                  this.savedBranches[i].email.toLowerCase() ==
                  event.toLowerCase()
                ) {
                  this.emailExists = true;
                  break;
                } else {
                  this.emailExists = false;
                }
              }
            }
          });
          var domain = event.replace(/.*@/, "");
          var domainName = domain.split(".");
          if (domainName[0]) {
            RegisterService.restrictEmail(domainName[0]).then(resp => {
              if (resp.response == false) {
                this.restrictEmail = true;
              } else{
                this.restrictEmail = false;
              }
            });
          }
        }
      }
      this.branchContactEmail = event;
    },
    allFieldsPresent() {
      if (
        this.selectedPartnerType &&
        this.branchName &&
        this.branchStreet &&
        this.selectedCountry &&
        this.selectedState &&
        this.selectedCity &&
        this.branchZipCode &&
        this.branchContactPerson &&
        this.branchContactDesignation &&
        this.branchContactMobile &&
        this.branchContactEmail &&
        this.branchNameExist == false &&
        this.branchStreetExist == false &&
        this.mobileNumberExists == false &&
        this.emailExists == false &&
        this.zipCodeValid == false &&
        this.mobileNumberValid == false &&
        this.emailValid == false
      ) {
        return true;
      } else {
        return false;
      }
    },
    saveBranchDetails() {
      this.loading = true;
      var branchGroupRequest = {
        categoryCode: this.selectedPartnerType,
        companyCode: this.selectedCompanyCode,
        branch: [
          {
            branchId: this.isEdit == true ? this.editBranch.branchId : "",
            name: this.branchName,
            address: {
              streetAddress: this.branchStreet,
              countryCode: this.selectedCountry,
              stateCode: this.selectedState,
              cityCode: this.selectedCity,
              postalCode: this.branchZipCode,
              slNo: ""
            },
            contact: {
              name: this.branchContactPerson,
              designation: this.branchContactDesignation,
              mobile: this.branchContactMobile,
              email: this.branchContactEmail
            }
          }
        ],
        statusCode: 7
      };
      partnerService
        .savePartnerBranchDetails(branchGroupRequest)
        .then(res => {
          if (res) {
            this.loading = false;
            this.triggerModalWidget = true;
            this.lastResponse = "Branch Details Saved successfully";
            this.successModal = true;
            EventBus.$emit("closeaddbranchpopup");
          }
        })
        .catch(err => {
                window.alert("Something went wrong! try again later");
          console.log(err);
        });
    },
    submitBranchDetails() {
      this.triggerConfirmModal = true;
      this.lastResponseConfirm = "Are you sure want to submit?";
    },
    changeModalSuccess() {
      this.triggerModalWidget = false;
      this.lastResponse = "";
      this.successModal = false;
      this.$emit("eventClose", event);
    },
    clearAllFields() {
      this.selectedPartnerType = "";
      this.branchName = "";
      this.branchStreet = "";
      // this.selectedCountry="";
      this.selectedState = "";
      this.selectedCity = "";
      this.branchZipCode = "";
      this.contactPersonName = "";
      this.contactPersonDesignation = "";
      this.branchContactMobile = "";
      this.branchContactEmail = "";
      this.branchNameExist = false;
      this.branchStreetExist = false;
      this.mobileNumberExists = false;
      this.emailExists = false;
    },
    callAfterConfirmModal() {
      this.triggerConfirmModal = false;
      this.loading = true;
      if(!this.isCustomer) {
      var branchGroupRequest = {
        categoryCode: this.selectedPartnerType,
        companyCode: this.selectedCompanyCode,
        branch: [
          {
            branchId: "",
            name: this.branchName,
            address: {
              streetAddress: this.branchStreet,
              countryCode: this.selectedCountry,
              stateCode: this.selectedState,
              cityCode: this.selectedCity,
              postalCode: this.branchZipCode,
              slNo: ""
            },
            contact: {
              name: this.branchContactPerson,
              designation: this.branchContactDesignation,
              mobile: this.branchContactMobile,
              email: this.branchContactEmail
            }
          }
        ],
        statusCode: 4
      };
      partnerService
        .savePartnerBranchDetails(branchGroupRequest, this.pId)
        .then(res => {
           if (res.failureMessage != "") {
              window.alert(res.failureMessage);
              this.loading = false;
            } 
            if (res.status == "SUCCESS") {
            this.loading = false;
            window.alert(res.response)   
            EventBus.$emit("closeaddbranchpopup");
            EventBus.$emit("eventadminreload", 'branchadded');
            }
        })
        .catch(err => {
                window.alert("Something went wrong! try again later");
          console.log(err);
        });
      } else if (this.isCustomer) {
        var data ={
                "branch": [
                  {
                    "address": {
                      "cityCode": this.selectedCity,
                      "countryCode": this.selectedCountry,
                      "postalCode": this.branchZipCode,
                      "slNo": 1,
                      "stateCode": this.selectedState,
                      "streetAddress": this.branchStreet
                    },
                    "contact": {
                      "country": ((this.branchCountries.filter(x=>x.value==this.selectedCountry))[0]).text,
                      "designation": this.branchContactDesignation,
                      "email": this.branchContactEmail,
                      "isdCode": this.phoneNumberCode,
                      "mobile": this.branchContactMobile,
                      "name": this.branchContactPerson
                    },
                    "name": this.branchName
                  }
                ],
                "categoryCode": 5,
                "companyCode": this.selectedCompanyCode,
                "partnerId": this.pId
              }

              
      partnerService
        .saveCustomerBranchDetails(data)
        .then(res => {
          if (res) {
            this.loading = false;
            this.selectedPartnerType = "";
            this.branchName = "";
            this.branchStreet = "";
            this.selectedCountry = "";
            this.selectedState = "";
            this.selectedCity = "";
            this.branchZipCode = "";
            this.branchContactPerson = "";
            this.branchContactDesignation = "";
            this.branchContactMobile = "";
            this.branchContactEmail = "";
            this.triggerModalWidget = true;
            this.lastResponse = "Branch Details Submitted successfully";
            this.successModal = true;
            EventBus.$emit('customerBranchAdded')
          }
        })
        .catch(err => {
                window.alert("Something went wrong! try again later");
          console.log(err);
        });
      }
    },
    closeConfirmModal() {
      this.triggerConfirmModal = false;
    }
  }
};
</script>

<style scoped>
.add-branch-btn-class {
  width: 100px;
  height: 30px;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  color: white !important;
  border-radius: 2px;
  background-color: #1579ab;
  /* display: block; */
  margin-left: auto !important;
}
.add-branch-btn-class:disabled {
  color: white !important;
}
</style>
